<template>
  <body>
    <EnviromentalImpact />
    <SustainabilityContent />
    <Footer />
  </body>
</template>

<script>
import EnviromentalImpact from "../components/Sustainability/EnviromentImpact.vue";
import SustainabilityContent from "../components/Sustainability/SustainabilityContent.vue";
import Footer from "@/components/SharedComponents/Footer.vue";

export default {
  name: "sustainability",
  components: {
    EnviromentalImpact,
    SustainabilityContent,
    Footer,
  },
};
</script>

<style></style>
